<template>
  <aha-modal
    v-if="isModalVisible"
    :classesModal="['local-file-uploader', modalClass]"
    @mouseup.stop
    :title="modalTitle"
    @hide="hide()"
    classes="mb-6"
    :size="modalSize"
    :hideHeader="hideHeader"
    :noCloseOnBackdrop="noCloseOnBackdrop"
  >
    <slot name="headerSection" />
    <slot name="additionalInformationSection" />
    <LocalFileUploader
      v-if="selectedTab === ActiveTabNames.UPLOAD"
      :staticState="staticState"
      :uploadingState="uploadingState"
      :convertingState="convertingState"
      :uploadError="uploadError"
      :featureName="featureName"
      :needGenerateQuiz="needGenerateQuiz"
      :instructionText="instructionText"
      :customPropsForTracking="customPropsForTracking"
      :fileFormat="fileFormat"
      :icon="icon"
      :dropPlaceholder="dropPlaceholder"
      :isTabUploadImage="isTabUploadImage"
    />
    <slot
      name="secondTabContentSection"
      v-if="isSecondTabContentVisible"
    />
    <slot name="footerSection" />
  </aha-modal>
</template>

<script>
import LocalFileUploader from '@/components-v2/presentation-editor/uploader/LocalFileUploader.vue'
import UploadFeatureName from '@/constant/uploadFeatureName'
import ActiveTabNames from '@/constant/ActiveTabNames'

export default {
  components: {
    LocalFileUploader,
  },
  props: {
    modalClass: {
      type: String,
      default: '',
    },
    modalSize: {
      type: String,
      default: 'xl',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: '',
    },
    isModalVisible: {
      type: Boolean,
      default: false,
    },
    staticState: {
      type: Boolean,
      default: false,
    },
    uploadingState: {
      type: Boolean,
      default: false,
    },
    convertingState: {
      type: Boolean,
      default: false,
    },
    uploadError: {
      type: String,
      default: null,
    },
    featureName: {
      type: String,
      default: null,
    },
    needGenerateQuiz: {
      type: Boolean,
      default: false,
    },
    instructionText: {
      type: String,
      default: null,
    },
    customPropsForTracking: {
      type: Object,
      default: () => ({}),
    },
    fileFormat: {
      type: String,
      default: '.ppt, .pptx, .pdf',
    },
    icon: {
      type: Object,
      default: () => ({
        name: 'import-no-background',
        width: '68',
        height: '68',
        viewBox: '0 0 69 69',
      }),
    },
    dropPlaceholder: {
      type: String,
      default: 'drop image',
    },
    selectedTab: {
      type: String,
      default: ActiveTabNames.UPLOAD,
    },

    // UPLOAD IMAGE
    signedCFUrlExpiryDate: {
      type: Number,
      default: null,
    },
    featureToUploadImage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      UploadFeatureName,
      ActiveTabNames,
    }
  },
  computed: {
    isTabUploadImage() {
      return this.selectedTab === ActiveTabNames.UPLOAD && this.featureName === UploadFeatureName.UPLOAD_IMAGE
    },
    isSecondTabContentVisible() {
      return this.selectedTab !== this.ActiveTabNames.UPLOAD
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>

<style lang="scss">
.local-file-uploader {
  .aha-modal__body {
    position: relative;
  }
  .aha-modal__header--text-content {
    font-size: 1.25rem /* 20px */;
    line-height: 1.75rem /* 28px */;
  }
  /* UPLOAD AUDIO */
  .upload-audio__existing-files {
    height: 240px;
    .existing-files__table {
      width: 100%;
      margin-bottom: 1rem;
      color: #313131;
    }
    .existing-files__table-header {
      border-bottom: 2px solid #ddd;
    }
    .existing-files__table-header-text {
      padding: 0.4rem 0;
    }
    .existing-files__table-content {
      padding: 0.6rem 0;
    }
    .existing-files__table-audio {
      border: 2px solid #ccc;
      border-radius: 30px;
      height: 32px;
      max-width: 380px;
      display: block;
    }
  }
  .modal__title--tab {
    border-bottom: 1px solid #ddd;
    margin-bottom: 1rem;
    text-align: center;

    a {
      display: inline-block;
      padding: 0 16px;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      padding-bottom: 10px;
      margin-bottom: -1px;
      @apply text-secondary-100;

      &.active {
        border-bottom: 2px solid #348EF6;
        color: #348EF6;
      }
    }
    &.center {
      text-align: center;
    }
  }
}

/* UPLOAD IMAGE ------------------------------------------------- */
/* CSS here since .upload-image-modal is a prop: classesModal for aha-modal */
.upload-image-modal {
  .aha-modal__content {
    overflow-y: hidden;
    @media (max-width: 767px) {
      width: 100%;
    }
  }

  .aha-modal__body {
    overflow-y: hidden;
    height: 100%;
    padding: 1rem 0 1.5rem;
  }
  /* Tab: Upload */
  .tab-content.is-tab-upload-image {
    height: calc(100% - 52px);
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    label:hover{
      background-color: #F0F4FA;
    }
    .custom-file-input {
      position: relative;
      z-index: 2;
      width: 100%;
      height: calc(1.5em + 0.75rem + 2px);
      margin: 0;
      opacity: 0;
    }
  }

  /* Tab: My photo */
  .my-photo {
    height: calc(100% - 12px) !important; /* bootstrap old CSS */
    padding: 20px 0 !important;
  }
  .my-photo-content {
    height: calc(100% - 62px) !important; /* bootstrap old CSS */
    &.empty {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  /* Tabs: Unsplash + Giphy */
  #infinite-list.tab-content, #infinite-giphy-list.tab-content {
    overflow-y: auto;
    -ms-overflow-style: auto;
    padding: 0 32px;
    height: calc(100% - 65px);
    margin-top: 24px;

    label {
      width: 100%;
      border: 2px dashed #ccc;
      border-radius: 8px;
      text-align: center;
      position: relative;
      cursor: pointer;
      height: 100%;
      transition: all 0.2s ease;

      &:hover {
        border: 2px dashed #348EF6;
      }

      .fas.fa-image {
        color: #348EF6;
      }

      &.error {
        border-color: red;
      }

      .custom-file {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        opacity: 0;
      }
    }
  }
  .input-search {
    background-color: #ffffff;
    z-index: 1;
    width: 100%;
    height: 44px;
    border: 1px solid #ddd;
    width: 100%;
    input {
      height: 100%;
      width: 100%;
      padding: .375rem .75rem;
      font-size: .875rem;
      line-height: 1.5;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      overflow: visible;
      margin: 0;
    }
  }
  .spinner {
    position: absolute;
    justify-content: center;
    bottom: 0;
    left: 0;
    transform: translateY(-50%);
    height: 15px;
  }
  .list-image {
    position: relative;
    overflow: hidden;
    margin-top: 21px;
    .list-image--no-result {
      text-align: center;
      font-size: 1em;
    }
    @media (max-width: 768px) {
      margin-top: 11px;
    }
    .item-image {
      width: 25%;
      float: left;
      padding: 5px;
      cursor: pointer;

      .img-bg {
        position: relative;
      }
      .img-info {
        position: absolute;
        bottom: 0;
        background: #0000005e;
        color: #ffffff;
        font-size: 13px;
        padding: 5px;
        text-align: center;
        display: none;
        width: 100%;
        .img-info__link, .img-info__unsplash-link {
          color: #ffffff !important;
        }
        img {
          width: 50%;
        }
      }
    }
  }
  .hide-loading-image {
    opacity: 0;
  }
  .img-info {
    position: absolute;
    bottom: 0;
    background: #0000005e;
    color: #ffffff;
    font-size: 13px;
    padding: 5px;
    text-align: center;
    display: none;
    width: 100%;
    .img-info__link, .img-info__unsplash-link {
      color: #ffffff !important;
    }
    img {
      width: 50%;
    }
  }

  /* Tab: Giphy */
  #infinite-giphy-list {
  .img-bg {
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 160px;

      .img-info__link {
        text-decoration: underline !important;
      }

      &:hover {
        cursor: pointer;
        .img-info {
          display: block;
        }
      }
    }
  }
  .btn-giphy--type {
    display: flex;
    .item{
      padding: 8px 16px;
      border-radius: 40px;
      background-color: #fff;
      border: 1px solid #D3D7E1;
      cursor: pointer;
      margin-left: 8px;
      transition: all 0.3s ease;
      display: inline-block;
      &.giphyType{
        margin-left: 4px;
      }
      &.active{
        background-color: #348EF6;
        color: #fff;
        border-color: #348EF6;
      }
      &.gif{
        @media (max-width: 768px) {
          margin-left: 0;
        }
      }
      &.gif, &.sticker {
        @media (max-width: 768px) {
          padding: 0 10px;
          display: flex;
          align-items: center;
          font-size: 0.875em;
          height: 35px;
        }
      }
      &:not(.active){
        &:hover, &:focus{
          border-color: #348EF6;
          color: #348EF6;
        }
      }
    }
    .bg-giphy-type{
      width: 103px;
      height: 38px;
      background-color: red;
      left: 0;
      top: 0;
    }
    @media (max-width: 768px) {
      margin-top: 8px;
    }
  }

  .search-giphy-group{
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 768px) {
      flex-wrap: wrap;
   }
  }
  .item-image-group{
    position: relative;
    .bg-sticker{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-image: url('../../assets/images/bg-tile-dark.png');
    }
  }
  .tab-giphy {
    &.__wrapper {
      display: inline-flex !important;
    }
    &.__icon {
      width: 30px;
      display: block;
      margin-left: 0.125rem;
      margin-top: -2px;
    }
  }

  .list-giphy-container {
    overflow-y: overlay !important;
  }
}

@media (max-width: 300px) {
  .upload-image-modal {
    a {
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }
}
</style>
